module.exports = __webpack_public_path__ + "static/img/充装-act.52b0c57f.png";